export class Timecode {
  static durationToSpeech(input: number): string {
    if (!input) {
      return "0 Seconds";
    }
    const parts: string[] =
      input.toString().indexOf(":") > 0
        ? input.toString().split(":")
        : Timecode.secondsToTimecode(input)!.split(":");
    const value: string[] = [];
    switch (parts.length) {
      case 1:
        let sec = parts[0];
        value.push(
          parseInt(sec, 0) !== 1
            ? parseInt(sec, 0) + " Seconds"
            : parseInt(sec, 0) + " Second"
        );
        break;
      case 2:
        let min = parts[0];
        sec = parts[1];
        if (min) {
          value.push(
            parseInt(min, 0) !== 1
              ? parseInt(min, 0) + " Minutes"
              : parseInt(min, 0) + " Minute"
          );
        }
        value.push(
          parseInt(sec, 0) !== 1
            ? parseInt(sec, 0) + " Seconds"
            : parseInt(sec, 0) + " Second"
        );
        break;
      case 3:
        const hr = parts[0];
        min = parts[1];
        sec = parts[2];
        value.push(
          parseInt(hr, 0) !== 1
            ? parseInt(hr, 0) + " Hours"
            : parseInt(hr, 0) + " Hour"
        );
        value.push(
          parseInt(min, 0) !== 1
            ? parseInt(min, 0) + " Minutes"
            : parseInt(min, 0) + " Minute"
        );
        value.push(
          parseInt(sec, 0) !== 1
            ? parseInt(sec, 0) + " Seconds"
            : parseInt(sec, 0) + " Second"
        );
        break;
    }
    return value.toString().replace(",", " ");
  }

  static secondsToTimecodeMaxWidth(input: any): string {
    const timecode = Timecode.secondsToTimecode(input);
    let result = "";
    const len = timecode!.length;
    for (let i = 0; i < len; i++) {
      result += " ";
    }
    return result;
  }

  static timecodeToSeconds(input: any): number {
    const temp: any = input.split(":").reverse();
    let value = 0;
    for (let i = temp.length - 1; i >= 0; i--) {
      value += Number(temp[i] * Math.pow(60, i));
    }
    return Math.round(value);
  }

  static secondsToTimecode(input: number, format?: string): string | undefined {
    if (typeof format === "undefined" || format.length !== 3) {
      format = ":: ";
    }
    if (input) {
      const hours: any = Math.floor(input / 60 / 60).toString();
      const minutes: any =
        Math.floor((input / 60) % 60) <= 9
          ? "0" + Math.floor((input / 60) % 60).toString()
          : Math.floor((input / 60) % 60).toString();
      const seconds: any =
        Math.floor((input % 60) % 60) <= 9
          ? "0" + Math.floor((input % 60) % 60).toString()
          : Math.floor((input % 60) % 60).toString();
      if (hours > 0) {
        return (
          (hours.indexOf("0") === 0 ? hours.replace("0", "") : hours) +
          format.substring(0, 1) +
          minutes +
          format.substring(1, 2) +
          seconds +
          format.substring(2, 3)
        );
      }
      if (minutes > 0) {
        return (
          (minutes.indexOf("0") === 0 ? minutes.replace("0", "") : minutes) +
          format.substring(1, 2) +
          seconds +
          format.substring(2, 3)
        );
      }
      if (seconds) {
        return "0" + format.substring(1, 2) + seconds + format.substring(2, 3);
      }
    } else {
      return (
        /*'0'+format.substring(0,1) + '0*/ "0" +
        format.substring(1, 2) +
        "00" +
        format.substring(2, 3)
      );
    }
  }
  static getHumanizeDuration(durationStr: string) {
    if (durationStr) {
      const timesArray = durationStr.split(":");
      const hd = ["Y", "M", "D", "H", "M", "S"];
      let humanizeDuration = "";
      let hdLength = hd.length - 1;
      for (let k = timesArray.length - 1; k > -1; k--) {
        humanizeDuration = timesArray[k] + hd[hdLength--] + humanizeDuration;
        if (hdLength === 2) {
          humanizeDuration = "T" + humanizeDuration;
        }
        if (hdLength === -1) {
          humanizeDuration = "P" + humanizeDuration;
        }
      }
      if (hdLength > 2) {
        humanizeDuration = "PT" + humanizeDuration;
      } else if (hdLength > 0) {
        humanizeDuration = "P" + humanizeDuration;
      }
      return humanizeDuration;
    } else {
      return "";
    }
  }
}
